import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { Checkout } from "../PayPalCheckout/Checkout";
import { useTranslation } from "react-i18next";
import { Modal, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useCart } from "./CartContext";
import { useEffect, useState } from "react";
import classes from "./CartModal.module.css";
import { useLocation } from "react-router-dom";
import React from "react";
import { DEBUG } from "../..";

const initialOptions = {
    clientId: "ASDzGW8u7SIlQLlxhzw8Ccym2OnE4tNlDqsP8mFOFjfBoYhnEF-QhzRGVsO55G3GB8KlDZLKVXPa8YYV", // Sandbox — TODO: replace with LMU TV prod clientId before launch
    currency: "EUR",
    intent: "capture",
    disableFunding: "credit",
};

interface CartProps {
    logged_in: boolean;
}

function checkForCart(iterator: IterableIterator<string>): boolean {
    return Array.from(iterator).includes('cart');
}
function checkForSteamCart(iterator: IterableIterator<string>): boolean {
    return Array.from(iterator).includes('scart');
}

export function CartModal({ logged_in }: CartProps) {
    const location = useLocation();
    const [steamCartRedirect, setSteamCart] = useState<boolean>();
    const { t } = useTranslation("translation");
    const isMobile = useMediaQuery("(max-width: 50em)");
    const { opened, openCart, closeCart } = useCart();

    useEffect(() => {
        if (DEBUG) console.log("opened cart ", opened);
    }, [opened]);

    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const modalParam = checkForCart(params.keys());
        const steamModalParam = checkForSteamCart(params.keys());
        if (modalParam) openCart();
        else if (steamModalParam) setSteamCart(true);
        else closeCart();
    }, [location.search]);

    useEffect(() => {
        if (steamCartRedirect && logged_in) openCart();
    }, [logged_in]);

    return (
        <Modal
            className={classes.cartModal}
            size="xl"
            opened={opened && logged_in}
            onClose={closeCart}
            title={<Title>{t("cart.title")}</Title>}
            fullScreen={isMobile}>
            <PayPalScriptProvider options={initialOptions}>
                <Checkout logged_in={logged_in} />
            </PayPalScriptProvider>
        </Modal>
    );
}
